$(function () {
	'use strict';

	var shareCalculatorContainer = $('#sharcalculator-form');
	var resultsContainer = $('#sharecalclulator-results-container');
	var historyContainer = document.getElementById('sharecalclulator-history-container');

	$.support.cors = true;

	if (!shareCalculatorContainer.length) {
		return;
	}

	cision.websolution.sharecalculator.render();
	shareCalculatorContainer.removeClass('is-loading');

	// We want nice select-boxes.
	documentReadyFunctions(shareCalculatorContainer);

	shareCalculatorContainer.on('submit', function (event) {
		shareCalculatorCompute();
		event.preventDefault();
	});

	function shareCalculatorCompute() {
		whenMutated(historyContainer).then(initResponsiveTableAndAnimate);
		cision.websolution.sharecalculator.compute();
	}

	function initResponsiveTableAndAnimate () {
		$(historyContainer)
			.find('table')
			.columnpicker()
			.tablescroll({
				// Overriding the default media query to make the table able
				// to get scroll on larger screens.
				mediaquery: 'screen'
			});

		/*
			NOTE: Would be nice to have sticky header, but that
			functionality is broken. See corrosion-compare component
		*/
		// $('#sharecalclulator-history-container thead')
		// 	.stickytableheaders();
		$('html').animate({
			scrollTop:  resultsContainer.offset().top - 100
		}, 800);
	}
});